import { render, staticRenderFns } from "./IncidentCreateOrUpdate.vue?vue&type=template&id=57c86080&"
import script from "./IncidentCreateOrUpdate.vue?vue&type=script&lang=js&"
export * from "./IncidentCreateOrUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports